"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var useTableData = function (_a) {
    var _b = _a.leaderBoardWithPrizes, leaderBoardWithPrizes = _b === void 0 ? [] : _b, tournamentPosition = _a.tournamentPosition, isFinished = _a.isFinished;
    var t = (0, next_intl_1.useTranslations)('translation');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    return (0, react_1.useMemo)(function () {
        var columnsDefault = [
            {
                field: 'position',
                label: t('position'),
            },
            {
                field: 'player',
                label: t('player'),
            },
            {
                field: 'points',
                label: t('points'),
            },
        ];
        var columns = !isFinished
            ? columnsDefault
            : __spreadArray(__spreadArray([], columnsDefault, true), [
                {
                    field: 'prize',
                    label: t('prize'),
                },
            ], false);
        var table = {
            columns: columns,
            rows: [],
        };
        table.rows = leaderBoardWithPrizes.map(function (item, idx) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return {
                position: react_1.default.createElement("span", null, idx + 1),
                player: react_1.default.createElement("span", null, item.user.nickname || t('anonymous')),
                points: (react_1.default.createElement("span", null, (item === null || item === void 0 ? void 0 : item.value) || (item === null || item === void 0 ? void 0 : item.value) === 0
                    ? (0, apps_shared_1.convertThousands)(item === null || item === void 0 ? void 0 : item.value.toFixed(2))
                    : (0, apps_shared_1.convertThousands)(Number((item === null || item === void 0 ? void 0 : item.totalSpent) || 0).toFixed(2) || 0))),
                prize: (react_1.default.createElement("span", null, (((_a = item === null || item === void 0 ? void 0 : item.prize) === null || _a === void 0 ? void 0 : _a.amount) || 0) > 0
                    ? "".concat((_b = item === null || item === void 0 ? void 0 : item.prize) === null || _b === void 0 ? void 0 : _b.amount, " ").concat(currentCurrency)
                    : ((_c = item === null || item === void 0 ? void 0 : item.prize) === null || _c === void 0 ? void 0 : _c.freeSpins)
                        ? "".concat(item === null || item === void 0 ? void 0 : item.prize.freeSpins, " ").concat(t('fs').toLocaleUpperCase())
                        : ((_d = item === null || item === void 0 ? void 0 : item.prize) === null || _d === void 0 ? void 0 : _d.loyaltyExp)
                            ? "".concat(item === null || item === void 0 ? void 0 : item.prize.loyaltyExp, " ").concat(t('loyalExp').toLocaleUpperCase())
                            : ((_e = item === null || item === void 0 ? void 0 : item.prize) === null || _e === void 0 ? void 0 : _e.loyaltyPoints)
                                ? "".concat(item === null || item === void 0 ? void 0 : item.prize.loyaltyPoints, " ").concat(t('points').toLocaleUpperCase())
                                : ((_f = item === null || item === void 0 ? void 0 : item.prize) === null || _f === void 0 ? void 0 : _f.physicalReward)
                                    ? (_g = item === null || item === void 0 ? void 0 : item.prize) === null || _g === void 0 ? void 0 : _g.physicalReward.toLocaleUpperCase()
                                    : ((_h = item === null || item === void 0 ? void 0 : item.prize) === null || _h === void 0 ? void 0 : _h.bonus)
                                        ? "".concat(((_j = item === null || item === void 0 ? void 0 : item.prize) === null || _j === void 0 ? void 0 : _j.bonus.percents) || '', " ").concat(((_l = (_k = item === null || item === void 0 ? void 0 : item.prize) === null || _k === void 0 ? void 0 : _k.bonus) === null || _l === void 0 ? void 0 : _l.amount) ? (_o = (_m = item === null || item === void 0 ? void 0 : item.prize) === null || _m === void 0 ? void 0 : _m.bonus) === null || _o === void 0 ? void 0 : _o.amount : '', " ").concat(((_q = (_p = item === null || item === void 0 ? void 0 : item.prize) === null || _p === void 0 ? void 0 : _p.bonus) === null || _q === void 0 ? void 0 : _q.freespins)
                                            ? ((_s = (_r = item === null || item === void 0 ? void 0 : item.prize) === null || _r === void 0 ? void 0 : _r.bonus) === null || _s === void 0 ? void 0 : _s.amount)
                                                ? '+ '
                                                : '' + ((_t = item === null || item === void 0 ? void 0 : item.prize) === null || _t === void 0 ? void 0 : _t.bonus.freespins) + t('fs')
                                            : '')
                                        : '-')),
                className: tournamentPosition && tournamentPosition.position === idx + 1
                    ? styles_module_scss_1.default.containerCurrent
                    : '',
            };
        });
        return table;
    }, [
        tournamentPosition,
        currentCurrency,
        isFinished,
        leaderBoardWithPrizes,
        t,
    ]);
};
exports.useTableData = useTableData;
